<app-navigation></app-navigation>

<div class="terms-container">
  <div class="terms-hero">
    <h1>Términos y Condiciones</h1>
    <p class="last-updated">Última actualización: {{ lastUpdated }}</p>
  </div>

  <div class="terms-content">
    <section class="terms-section">
      <h2>1. Aceptación de los Términos</h2>
      <p>
        Al acceder, registrarse o utilizar la plataforma <strong>Chatbot Pezeta</strong>, operada por <strong>Pezeta Solutions</strong> (en adelante, "la Empresa", "nosotros" o "nuestro"), usted (en adelante, "el Cliente" o "usted") acepta quedar vinculado por estos Términos y Condiciones (en adelante, "los Términos"), nuestra <a routerLink="/politicas-de-privacidad">Política de Privacidad</a> y cualquier política adicional que se incorpore por referencia.
      </p>
      <p>
        Si no está de acuerdo con alguno de estos Términos, le pedimos que no utilice nuestros servicios. Si está aceptando en nombre de una empresa u otra entidad legal, declara y garantiza que tiene la autoridad para vincular a dicha entidad con estos Términos.
      </p>
      <p>
        La Empresa se reserva el derecho de modificar estos Términos en cualquier momento. Las modificaciones entrarán en vigor una vez publicadas en esta página. El uso continuado del servicio después de dicha publicación constituirá su aceptación de los nuevos términos.
      </p>
    </section>

    <section class="terms-section">
      <h2>2. Descripción del Servicio</h2>
      <p>
        Chatbot Pezeta es una plataforma de software como servicio (SaaS) que permite a empresas automatizar su atención al cliente mediante chatbots con inteligencia artificial integrados a:
      </p>
      <ul>
        <li><strong>WhatsApp Business API</strong> (a través de la infraestructura de Meta Platforms)</li>
      </ul>
      <p>
        La plataforma incluye, entre otras funcionalidades:
      </p>
      <ul>
        <li>Gestión de conversaciones entrantes y salientes por WhatsApp</li>
        <li>Automatización de respuestas mediante modelos de lenguaje de inteligencia artificial (OpenAI GPT)</li>
        <li>CRM integrado para gestión de leads, oportunidades, cuentas y contactos</li>
        <li>Campañas de remarketing y envío masivo de mensajes (conforme a las políticas de Meta)</li>
        <li>Panel de administración multiusuario con roles y permisos</li>
        <li>Reportes, métricas y análisis de conversaciones</li>
        <li>Webhooks y herramientas de integración con sistemas externos</li>
      </ul>
      <p>
        El servicio se presta bajo el modelo de suscripción mensual. Las características disponibles varían según el plan contratado. Pezeta Solutions es un proveedor independiente de software y <strong>no es Meta Platforms, Inc.</strong> ni ninguna de sus subsidiarias o afiliadas; integramos nuestra plataforma con WhatsApp Business API mediante las herramientas que Meta pone a disposición de los desarrolladores.
      </p>
    </section>

    <section class="terms-section">
      <h2>3. Registro de Cuenta y Elegibilidad</h2>
      <h3>3.1 Elegibilidad</h3>
      <p>
        Para utilizar Chatbot Pezeta, usted debe:
      </p>
      <ul>
        <li>Ser mayor de <strong>18 años</strong> de edad</li>
        <li>Tener capacidad legal para celebrar contratos vinculantes bajo las leyes de México o del país donde opere</li>
        <li>Si actúa en representación de una empresa, contar con autorización expresa para contratar en nombre de dicha entidad</li>
        <li>No haber sido suspendido o inhabilitado previamente de la plataforma por violación de estos Términos</li>
      </ul>

      <h3>3.2 Registro y Seguridad de la Cuenta</h3>
      <p>
        Al registrarse, usted se compromete a proporcionar información veraz, completa y actualizada. Usted es responsable de mantener la confidencialidad de sus credenciales de acceso y de todas las actividades que ocurran bajo su cuenta. Debe notificarnos de inmediato ante cualquier uso no autorizado a través de <a href="mailto:contacto@pezetasolutions.com">contacto&#64;pezetasolutions.com</a>.
      </p>

      <h3>3.3 Verificación con Meta</h3>
      <p>
        Para habilitar la integración con WhatsApp Business API, el cliente deberá contar con una cuenta de WhatsApp Business Account (WABA) verificada por Meta Platforms. Pezeta Solutions podrá asistir en el proceso de configuración, pero la aprobación final depende exclusivamente de Meta. El incumplimiento de las políticas de Meta puede resultar en la suspensión de las funcionalidades de mensajería.
      </p>
    </section>

    <section class="terms-section">
      <h2>4. Uso Aceptable y Restricciones</h2>
      <h3>4.1 Compromisos del Cliente</h3>
      <p>Al utilizar Chatbot Pezeta, el Cliente se compromete a:</p>
      <ul>
        <li>Utilizar el servicio únicamente para fines legales y comerciales legítimos</li>
        <li>Obtener el consentimiento explícito (Opt-In) de los usuarios finales antes de enviarles mensajes de marketing o notificaciones proactivas por WhatsApp</li>
        <li>Cumplir con todas las leyes de protección de datos aplicables, incluyendo la LFPDPPP (México) y, en su caso, el GDPR</li>
        <li>No enviar mensajes no solicitados, spam, contenido engañoso o fraudulento</li>
        <li>Respetar los horarios y frecuencias de mensajería que Meta establece en sus políticas</li>
        <li>Mantener actualizada la información de su cuenta y datos de facturación</li>
      </ul>

      <h3>4.2 Contenido Prohibido</h3>
      <p>Queda estrictamente prohibido utilizar la plataforma para:</p>
      <ul>
        <li>Enviar contenido que viole las <a href="https://www.whatsapp.com/legal/business-policy/" target="_blank" rel="noopener noreferrer">Políticas de WhatsApp Business</a> o los <a href="https://developers.facebook.com/terms/" target="_blank" rel="noopener noreferrer">Términos de la Plataforma de Meta</a></li>
        <li>Distribuir contenido ilegal, difamatorio, obsceno, pornográfico, amenazante, violento o que incite al odio</li>
        <li>Comercializar o promover productos o servicios prohibidos por las <a href="https://www.facebook.com/policies/commerce/" target="_blank" rel="noopener noreferrer">Directrices de Comercio de Meta</a> (incluyendo armas, drogas, servicios financieros regulados sin licencia, entre otros)</li>
        <li>Realizar actividades de phishing, suplantación de identidad o fraude</li>
        <li>Infringir derechos de propiedad intelectual de terceros</li>
        <li>Intentar acceder sin autorización a sistemas, redes o datos de la plataforma</li>
        <li>Realizar ingeniería inversa, descompilar o desensamblar cualquier parte del software</li>
        <li>Revender, sublicenciar o distribuir el acceso a la plataforma sin autorización escrita de Pezeta Solutions</li>
        <li>Recopilar datos de otros usuarios de la plataforma de forma automatizada</li>
      </ul>

      <h3>4.3 Consecuencias del Incumplimiento</h3>
      <p>
        El incumplimiento de cualquiera de las disposiciones de uso aceptable puede resultar en la suspensión inmediata o terminación definitiva de la cuenta, sin perjuicio de las acciones legales que correspondan y de la responsabilidad del Cliente por los daños causados.
      </p>
    </section>

    <section class="terms-section">
      <h2>5. Suscripción, Pagos y Cancelación</h2>
      <h3>5.1 Planes de Suscripción</h3>
      <p>
        Chatbot Pezeta se ofrece mediante planes de suscripción mensual. Los precios, características y límites de cada plan se detallan en nuestra página de precios. Pezeta Solutions se reserva el derecho de modificar los planes y precios con un aviso previo de al menos <strong>30 días naturales</strong>.
      </p>

      <h3>5.2 Facturación</h3>
      <p>
        La suscripción se factura por adelantado al inicio de cada ciclo mensual. Los pagos son no reembolsables, salvo en los casos expresamente establecidos en estos Términos o exigidos por ley. El Cliente es responsable de mantener información de pago válida y actualizada.
      </p>

      <h3>5.3 Impuestos</h3>
      <p>
        Los precios mostrados no incluyen impuestos aplicables. El IVA (16%) u otros impuestos serán añadidos según la legislación fiscal mexicana vigente y el régimen fiscal del Cliente.
      </p>

      <h3>5.4 Cancelación</h3>
      <p>
        El Cliente puede cancelar su suscripción en cualquier momento desde la configuración de la cuenta. La cancelación será efectiva al final del ciclo de facturación en curso. No se realizarán reembolsos por períodos parciales. Tras la cancelación, el acceso a la plataforma continuará hasta el final del período ya pagado.
      </p>

      <h3>5.5 Suspensión por Falta de Pago</h3>
      <p>
        En caso de falta de pago, Pezeta Solutions podrá suspender el acceso a la plataforma después de un aviso de <strong>5 días hábiles</strong>. Tras 30 días de suspensión sin regularización, la cuenta podrá ser terminada y los datos eliminados conforme a nuestra política de retención.
      </p>
    </section>

    <section class="terms-section">
      <h2>6. Integraciones de Terceros y Meta Platforms</h2>
      <h3>6.1 Naturaleza de las Integraciones</h3>
      <p>
        Chatbot Pezeta se integra con servicios de terceros, incluyendo Meta Platforms (WhatsApp Business API), OpenAI y Microsoft Azure. El uso de estas integraciones está sujeto a los términos de servicio y políticas de privacidad de cada proveedor.
      </p>

      <h3>6.2 Relación con Meta Platforms</h3>
      <p>
        Pezeta Solutions integra su plataforma con <strong>WhatsApp Business API</strong> mediante las herramientas que Meta Platforms pone a disposición de los desarrolladores. En esta relación:
      </p>
      <ul>
        <li>Facilitamos el acceso de nuestros clientes a la API de WhatsApp Business de Meta, pero <strong>no somos Meta</strong> ni representamos a Meta Platforms, Inc.</li>
        <li>El Cliente, al utilizar las funcionalidades de WhatsApp en la plataforma, acepta automáticamente las <a href="https://www.whatsapp.com/legal/business-policy/" target="_blank" rel="noopener noreferrer">Políticas de WhatsApp Business</a> y los <a href="https://developers.facebook.com/terms/" target="_blank" rel="noopener noreferrer">Términos de la Plataforma de Desarrolladores de Meta</a> en su versión vigente.</li>
        <li>El Cliente es responsable del cumplimiento de dichas políticas en el uso que hace de la plataforma y en las comunicaciones que envía a sus propios usuarios finales.</li>
        <li>Meta Platforms puede modificar, suspender o revocar el acceso a sus APIs en cualquier momento. Pezeta Solutions no será responsable por interrupciones del servicio derivadas de decisiones de Meta.</li>
        <li>El incumplimiento por parte del Cliente de las políticas de Meta puede resultar en la suspensión de su cuenta de WhatsApp Business Account (WABA), lo cual está fuera del control de Pezeta Solutions.</li>
      </ul>

      <h3>6.3 Responsabilidad sobre Terceros</h3>
      <p>
        Pezeta Solutions no es responsable por la disponibilidad, exactitud, contenido o prácticas de privacidad de servicios de terceros integrados. Los enlaces o accesos a servicios de terceros se proporcionan para su conveniencia y no implican respaldo o responsabilidad por parte de Pezeta Solutions.
      </p>
    </section>

    <section class="terms-section">
      <h2>7. Propiedad Intelectual</h2>
      <h3>7.1 Titularidad de Pezeta Solutions</h3>
      <p>
        La plataforma Chatbot Pezeta, incluyendo su código fuente, diseño, marcas, logotipos, documentación y demás contenidos, es propiedad exclusiva de Pezeta Solutions y está protegida por las leyes de propiedad intelectual de México y los tratados internacionales aplicables. Estos Términos no le otorgan ningún derecho de propiedad sobre el software ni sobre ninguno de sus componentes.
      </p>

      <h3>7.2 Licencia de Uso</h3>
      <p>
        Pezeta Solutions le otorga al Cliente una licencia limitada, no exclusiva, intransferible, revocable y no sublicenciable para acceder y utilizar la plataforma durante el período de suscripción activa, exclusivamente para sus fines comerciales internos y de conformidad con estos Términos.
      </p>

      <h3>7.3 Datos del Cliente</h3>
      <p>
        El Cliente conserva todos los derechos sobre los datos que ingresa o genera en la plataforma (incluyendo información de leads, conversaciones y configuraciones). El Cliente otorga a Pezeta Solutions una licencia limitada para procesar dichos datos con el único fin de prestar el servicio contratado. Pezeta Solutions no venderá ni cederá los datos del cliente a terceros, salvo lo necesario para la operación del servicio o por mandato legal.
      </p>

      <h3>7.4 Feedback</h3>
      <p>
        Si el Cliente proporciona sugerencias, ideas o feedback sobre la plataforma, Pezeta Solutions podrá utilizarlos libremente para mejorar el servicio sin obligación de compensación ni de mantener confidencialidad sobre dichas ideas.
      </p>
    </section>

    <section class="terms-section">
      <h2>8. Confidencialidad</h2>
      <p>
        Cada parte se compromete a mantener la confidencialidad de la información no pública que reciba de la otra parte en relación con este acuerdo ("Información Confidencial"), y a no divulgarla a terceros ni utilizarla para fines distintos a los previstos en estos Términos, durante el período del contrato y por un período de <strong>3 años</strong> posterior a su terminación.
      </p>
      <p>
        La obligación de confidencialidad no aplica a información que: (a) sea o se vuelva de dominio público sin culpa de la parte receptora; (b) sea conocida legítimamente por la parte receptora antes de recibirla; (c) sea divulgada por mandato legal o de autoridad competente, previa notificación oportuna a la otra parte.
      </p>
      <p>
        Pezeta Solutions implementa medidas de seguridad técnicas y organizativas razonables para proteger la información del cliente, incluyendo cifrado, control de accesos y auditorías de seguridad. Para mayor detalle, consulte nuestra <a routerLink="/politicas-de-privacidad">Política de Privacidad</a>.
      </p>
    </section>

    <section class="terms-section">
      <h2>9. Disponibilidad del Servicio y Soporte</h2>
      <h3>9.1 Disponibilidad (SLA)</h3>
      <p>
        Pezeta Solutions se compromete a mantener una disponibilidad objetivo del servicio del <strong>99% mensual</strong>, excluyendo mantenimientos programados y eventos fuera de su control (fuerza mayor, interrupciones de proveedores de nube como Azure, o interrupciones de las APIs de Meta).
      </p>

      <h3>9.2 Mantenimientos Programados</h3>
      <p>
        Pezeta Solutions notificará con al menos <strong>24 horas de anticipación</strong> cualquier mantenimiento programado que pueda afectar la disponibilidad del servicio. Los mantenimientos de emergencia podrán realizarse sin previo aviso en casos críticos de seguridad.
      </p>

      <h3>9.3 Soporte Técnico</h3>
      <p>
        El soporte técnico está disponible a través de los canales definidos en el plan de suscripción del cliente (email, chat o teléfono). Los tiempos de respuesta varían según el nivel de soporte contratado y la severidad del incidente. Pezeta Solutions no garantiza la resolución de incidentes que dependan de terceros como Meta, OpenAI o proveedores de telecomunicaciones.
      </p>

      <h3>9.4 Modificaciones del Servicio</h3>
      <p>
        Pezeta Solutions se reserva el derecho de modificar, mejorar o discontinuar funcionalidades de la plataforma, con notificación previa razonable al Cliente. No se realizarán modificaciones que reduzcan sustancialmente las funcionalidades principales del plan contratado sin ofrecer al Cliente la opción de cancelar sin penalización.
      </p>
    </section>

    <section class="terms-section">
      <h2>10. Limitación de Responsabilidad</h2>
      <p>
        En la máxima medida permitida por la ley aplicable:
      </p>
      <ul>
        <li>Pezeta Solutions no será responsable por daños indirectos, incidentales, especiales, consecuentes o punitivos, incluyendo pérdida de beneficios, pérdida de datos, interrupción del negocio o pérdida de oportunidades comerciales, aun cuando se haya advertido sobre la posibilidad de dichos daños.</li>
        <li>La responsabilidad total acumulada de Pezeta Solutions frente al Cliente, por cualquier causa, no excederá el monto total pagado por el Cliente durante los <strong>3 meses anteriores</strong> al evento que dio origen a la reclamación.</li>
        <li>Pezeta Solutions no garantiza que el servicio estará libre de errores, interrupciones o virus, ni que los resultados obtenidos mediante el uso del servicio cumplirán con las expectativas del Cliente.</li>
        <li>Pezeta Solutions no será responsable por las decisiones de Meta Platforms de modificar, suspender o cancelar el acceso a sus APIs, ni por el contenido de las conversaciones generadas por la IA.</li>
      </ul>
      <p>
        Algunas jurisdicciones no permiten la exclusión de ciertas garantías o la limitación de responsabilidad por ciertos tipos de daños, por lo que algunas de las limitaciones anteriores pueden no aplicarse en su caso.
      </p>
    </section>

    <section class="terms-section">
      <h2>11. Indemnización</h2>
      <p>
        El Cliente acepta defender, indemnizar y mantener indemne a Pezeta Solutions, sus directivos, empleados, socios y proveedores de cualquier reclamación, responsabilidad, daño, pérdida, costo o gasto (incluyendo honorarios legales razonables) que surja de o esté relacionado con:
      </p>
      <ul>
        <li>El uso del servicio por parte del Cliente o sus usuarios finales en violación de estos Términos</li>
        <li>El incumplimiento de las políticas de Meta Platforms por parte del Cliente</li>
        <li>Contenido enviado a través de la plataforma que infrinja derechos de terceros o leyes aplicables</li>
        <li>El tratamiento de datos personales de los usuarios finales del Cliente en incumplimiento de la LFPDPPP u otras leyes de protección de datos</li>
        <li>Cualquier reclamación de terceros derivada de las comunicaciones enviadas por el Cliente a través de la plataforma</li>
      </ul>
    </section>

    <section class="terms-section">
      <h2>12. Modificaciones a los Términos</h2>
      <p>
        Pezeta Solutions se reserva el derecho de modificar estos Términos en cualquier momento. Cuando se realicen cambios materiales, notificaremos al Cliente por correo electrónico con al menos <strong>15 días de anticipación</strong> a la entrada en vigencia de los nuevos términos, o mediante un aviso destacado en la plataforma.
      </p>
      <p>
        Si el Cliente no está de acuerdo con los nuevos términos, podrá cancelar su suscripción antes de la fecha de entrada en vigencia. El uso continuado del servicio después de dicha fecha constituirá la aceptación de los términos modificados.
      </p>
    </section>

    <section class="terms-section">
      <h2>13. Terminación</h2>
      <h3>13.1 Por el Cliente</h3>
      <p>
        El Cliente puede terminar su suscripción en cualquier momento siguiendo el proceso de cancelación descrito en la sección 5.4 de estos Términos.
      </p>

      <h3>13.2 Por Pezeta Solutions</h3>
      <p>
        Pezeta Solutions podrá suspender o terminar la cuenta del Cliente, con o sin previo aviso, en los siguientes casos:
      </p>
      <ul>
        <li>Incumplimiento material de estos Términos</li>
        <li>Falta de pago no regularizada en los plazos establecidos</li>
        <li>Uso del servicio para actividades ilegales o que violen las políticas de Meta</li>
        <li>Solicitud de autoridades competentes</li>
        <li>Decisión de descontinuar el servicio (con aviso previo de 60 días)</li>
      </ul>

      <h3>13.3 Efectos de la Terminación</h3>
      <p>
        Tras la terminación, el acceso a la plataforma se deshabilitará. Los datos del Cliente se retendrán durante un período máximo de <strong>90 días</strong> para permitir la exportación, tras los cuales serán eliminados definitivamente, salvo obligaciones legales de retención. Las secciones de estos Términos que por su naturaleza deban sobrevivir a la terminación (incluyendo confidencialidad, propiedad intelectual, limitación de responsabilidad e indemnización) continuarán en vigencia.
      </p>
    </section>

    <section class="terms-section">
      <h2>14. Ley Aplicable y Jurisdicción</h2>
      <p>
        Estos Términos se rigen e interpretan de conformidad con las leyes de los <strong>Estados Unidos Mexicanos</strong>, sin consideración a sus disposiciones sobre conflicto de leyes.
      </p>
      <p>
        Para la resolución de cualquier controversia derivada de estos Términos, las partes acuerdan someterse a la jurisdicción exclusiva de los tribunales competentes de la ciudad de <strong>Los Mochis, Sinaloa, México</strong>, renunciando expresamente a cualquier otro fuero que pudiera corresponderles por razón de sus domicilios presentes o futuros.
      </p>
      <p>
        Antes de iniciar cualquier procedimiento legal, las partes se comprometen a intentar resolver la disputa de buena fe mediante negociación directa durante un período de <strong>30 días naturales</strong> a partir de la notificación escrita de la disputa.
      </p>
    </section>

    <section class="terms-section">
      <h2>15. Información de Contacto</h2>
      <p>
        Si tiene preguntas, comentarios o inquietudes sobre estos Términos y Condiciones o sobre el servicio, puede contactarnos:
      </p>
      <div class="contact-info">
        <p><strong>Pezeta Solutions</strong></p>
        <p>Los Mochis, Sinaloa, México</p>
        <p>Email: <a href="mailto:contacto@pezetasolutions.com">contacto&#64;pezetasolutions.com</a></p>
        <p>Teléfono: +52 668 856 6833</p>
        <p>WhatsApp: <a href="https://wa.me/message/GTV3AEMP6MFNC1" target="_blank" rel="noopener">Contactar por WhatsApp</a></p>
      </div>
    </section>

    <section class="terms-section consent-section">
      <h2>Aceptación</h2>
      <p>
        Al utilizar la plataforma Chatbot Pezeta, usted reconoce que ha leído, comprendido y aceptado estos Términos y Condiciones en su totalidad, incluyendo nuestra <a routerLink="/politicas-de-privacidad">Política de Privacidad</a>. Si actúa en nombre de una empresa, declara tener autoridad para vincularla a estos Términos.
      </p>
    </section>
  </div>
</div>

<app-footer></app-footer>
